export default "__VITE_ASSET__M6F8G_6q__"